export { getUserAgent } from './UserAgentService'
export type { UserAgent } from './UserAgentService'
